import React, {} from 'react';
import { useSystemTheme } from './useSystemTheme.js';
/**
 * Applies the light or dark theme from the system setting, following changes live.
 * Everything inside resolves its design tokens from the `data-theme` wrapper; without a readable setting it is light.
 */
export function ThemeProvider({ children }) {
    const theme = useSystemTheme();
    return React.createElement("div", { "data-theme": theme }, children);
}
//# sourceMappingURL=ThemeProvider.js.map